<app-header></app-header>
<div class="content small-head">
  <mat-card appearance="outlined" class="info-card">
    <div>
      <h3>{{'KbTitle' | translate }}</h3>
    </div>





    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="lang-btns" value="fr">

      @for (lng of langs; track lng) {
        <mat-button-toggle mat-icon-button color="primary" aria-label="{{lng.desc}}" value="{{lng.name}}" (click)="setLang(lng.code)">
          <div class="flag-wrapper">
            <div class="flag flag-icon-background flag-icon-{{lng.name}}"></div>
          </div>
          <span>{{lng.desc}}</span>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    <mat-divider></mat-divider>
    <div class="select-training-text">
      <h3>{{'SelectWay' | translate }}</h3>
    </div>
    <!-- <mat-progress-spinner *ngIf="isLoadnig"
    class="spinner-margin"
    color="accent"
    [mode]="mode"
    diameter="100"
    [value]="value">
  </mat-progress-spinner> -->
  <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="train-btns-gate" value="{{selectedGate}}">
    @for (way of ways; track way; let indx = $index) {
      <mat-button-toggle mat-icon-button aria-label="" value="{{way.id}}" (change)="selectionChanged($event.value)">
        <span>{{way.name | translate}}</span>
        <mat-icon class="route-ico">{{way.icon}}</mat-icon>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
  <mat-divider></mat-divider>
  <button mat-raised-button color="primary" class="next-btn" [disabled]="isLoadnig" (click)=onClick()>{{'NextBtn' | translate}}</button>
</mat-card>
</div>

